/**
 * Who may open the Candidates register (GH #7057).
 *
 * The grant lives on the user's own record (`hrRecruitment`), and that record
 * is the one source of truth: users-crud is the only path that can change it
 * (super-admin only, GH #7741) and employee-send-magic-link reads it from the
 * same row on the server. The session never carries a copy, so a grant or a
 * revoke takes effect the next time the user list is read rather than at the
 * next login, and the client and the server can never disagree about it.
 *
 * Returns:
 *   true      — super-admin, or the signed-in user's record holds the grant
 *   false     — the record is loaded and does not hold it (or no session)
 *   null      — the user list has not loaded yet; the caller must wait, never
 *               treat "unknown" as either answer
 */
export function hrRecruitmentAccess(session, users, usersLoaded) {
  if (!session) return false;
  if (session.role === 'super-admin') return true;
  if (!usersLoaded) return null;
  const me = (users || []).find((u) => u && u.id === session.userId);
  return !!(me && me.hrRecruitment);
}
